import { ButtonIcon } from 'src/components/ui/Button'
import Icon from 'src/components/ui/Icon'
import { useCartToggleButton } from 'src/sdk/cart/useCartToggleButton'

function CartToggle() {
  const btnProps = useCartToggleButton()

  return (
    <ButtonIcon
      data-fs-button-cart="true"
      aria-label={`Cart with ${btnProps['data-items']} items`}
      icon={<Icon name="ShoppingCart" width={32} height={32} />}
      style={{ backgroundColor: 'transparent' }}
      {...btnProps}
    />
  )
}

export default CartToggle
